//
//
//
//

import { mapActions } from 'vuex';


export default {
  async mounted() {
    this.currenciesLoad();
  },

  methods: {
    ...mapActions('transactionsCurrencies', {
      currenciesLoad: 'loadData',
    }),
  },
};
